import * as api from '../api/menuprofile';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const MENUPROFILE_CHANGE_CURRENT_PAGE =
  'APPRAISAL/MENUPROFILE_CHANGE_CURRENT_PAGE';
export const MENUPROFILE_CHANGE_SORT_MODEL =
  'APPRAISAL/MENUPROFILE_CHANGE_SORT_MODEL';
export const MENUPROFILE_CHANGE_PAGE_SIZE =
  'APPRAISAL/MENUPROFILE_CHANGE_PAGE_SIZE';

export const MENUPROFILE_RESET_DATA = 'APPRAISAL/MENUPROFILE_RESET_DATA';
export const MENUPROFILE_FETCH_START = 'APPRAISAL/MENUPROFILE_FETCH_START';
export const MENUPROFILE_FETCH_SUCCESS = 'APPRAISAL/MENUPROFILE_FETCH_SUCCESS';
export const MENUPROFILE_FETCH_ERROR = 'APPRAISAL/MENUPROFILE_FETCH_ERROR';

export const MENUPROFILE_UPDATE_START = 'APPRAISAL/MENUPROFILE_UPDATE_START';
export const MENUPROFILE_UPDATE_SUCCESS =
  'APPRAISAL/MENUPROFILE_UPDATE_SUCCESS';
export const MENUPROFILE_UPDATE_ERROR = 'APPRAISAL/MENUPROFILE_UPDATE_ERROR';

export const MENUPROFILE_CREATE = createRequestTypes(
  'APPRAISAL/MENUPROFILE_CREATE',
);
export const MENUPROFILE_LIST_FETCH = createRequestTypes(
  'APPRAISAL/MENUPROFILE_LIST_FETCH',
);
export const MENUPROFILE_DELETE = createRequestTypes(
  'APPRAISAL/MENUPROFILE_DELETE',
);
export const MENUPROFILE_DUPLICATE = createRequestTypes(
  'APPRAISAL/MENUPROFILE_DUPLICATE',
);

export const MENU_DEFAULT_LIST_FETCH = createRequestTypes(
  'APPRAISAL/MENU_DEFAULT_LIST_FETCH',
);
export const MENU_DEFAULT_FETCH = createRequestTypes(
  'APPRAISAL/MENU_DEFAULT_FETCH',
);
export const MENU_DEFAULT_CREATE = createRequestTypes(
  'APPRAISAL/MENU_DEFAULT_CREATE',
);
export const MENU_DEFAULT_UPDATE = createRequestTypes(
  'APPRAISAL/MENU_DEFAULT_UPDATE',
);
export const MENU_DEFAULT_DELETE = createRequestTypes(
  'APPRAISAL/MENU_DEFAULT_DELETE',
);
export const PROPERTY_TYPES_AVAIL_FETCH = createRequestTypes(
  'APPRAISAL/PROPERTY_TYPES_AVAIL_FETCH',
);
export const MENU_PROFILES_AUTHORIZED_FETCH = createRequestTypes(
  'APPRAISAL/MENU_PROFILES_AUTHORIZED_FETCH',
);

export const fetchMenuprofiles = makeApiActionCreatorV3(
  api.fetchMenuprofiles,
  MENUPROFILE_LIST_FETCH[START],
  MENUPROFILE_LIST_FETCH[SUCCESS],
  MENUPROFILE_LIST_FETCH[ERROR],
);
export const fetchMenuprofile = makeApiActionCreatorV3(
  api.fetchMenuprofile,
  MENUPROFILE_FETCH_START,
  MENUPROFILE_FETCH_SUCCESS,
  MENUPROFILE_FETCH_ERROR,
);
export const updateMenuprofile = makeApiActionCreatorV3(
  api.updateMenuprofile,
  MENUPROFILE_UPDATE_START,
  MENUPROFILE_UPDATE_SUCCESS,
  MENUPROFILE_UPDATE_ERROR,
);
export const createMenuprofile = makeApiActionCreatorV3(
  api.createMenuprofile,
  MENUPROFILE_CREATE[START],
  MENUPROFILE_CREATE[SUCCESS],
  MENUPROFILE_CREATE[ERROR],
);
export const deleteMenuprofile = makeApiActionCreatorV3(
  api.deleteMenuprofile,
  MENUPROFILE_DELETE[START],
  MENUPROFILE_DELETE[SUCCESS],
  MENUPROFILE_DELETE[ERROR],
);
export const duplicateMenuprofile = makeApiActionCreatorV3(
  api.duplicateMenuprofile,
  MENUPROFILE_DUPLICATE[START],
  MENUPROFILE_DUPLICATE[SUCCESS],
  MENUPROFILE_DUPLICATE[ERROR],
);

export const fetchMenuDefaults = makeApiActionCreatorV3(
  api.fetchUserDefaultMenus,
  MENU_DEFAULT_LIST_FETCH[START],
  MENU_DEFAULT_LIST_FETCH[SUCCESS],
  MENU_DEFAULT_LIST_FETCH[ERROR],
);
export const fetchMenuDefault = makeApiActionCreatorV3(
  api.fetchUserDefaultMenu,
  MENU_DEFAULT_FETCH[START],
  MENU_DEFAULT_FETCH[SUCCESS],
  MENU_DEFAULT_FETCH[ERROR],
);
export const createMenuDefault = makeApiActionCreatorV3(
  api.createUserDefaultMenu,
  MENU_DEFAULT_CREATE[START],
  MENU_DEFAULT_CREATE[SUCCESS],
  MENU_DEFAULT_CREATE[ERROR],
);
export const updateMenuDefault = makeApiActionCreatorV3(
  api.updateUserDefaultMenu,
  MENU_DEFAULT_UPDATE[START],
  MENU_DEFAULT_UPDATE[SUCCESS],
  MENU_DEFAULT_UPDATE[ERROR],
);
export const deleteMenuDefault = makeApiActionCreatorV3(
  api.deleteUserDefaultMenu,
  MENU_DEFAULT_DELETE[START],
  MENU_DEFAULT_DELETE[SUCCESS],
  MENU_DEFAULT_DELETE[ERROR],
);
export const fetchPropertyTypesAvail = makeApiActionCreatorV3(
  api.fetchPropertiesAvailableForUser,
  PROPERTY_TYPES_AVAIL_FETCH[START],
  PROPERTY_TYPES_AVAIL_FETCH[SUCCESS],
  PROPERTY_TYPES_AVAIL_FETCH[ERROR],
);
export const fetchAuthorizedMenuProfiles = makeApiActionCreatorV3(
  api.fetchAuthorizedMenuProfiles,
  MENU_PROFILES_AUTHORIZED_FETCH[START],
  MENU_PROFILES_AUTHORIZED_FETCH[SUCCESS],
  MENU_PROFILES_AUTHORIZED_FETCH[ERROR],
);

export function changeCurrentPage(page) {
  return async dispatch => {
    dispatch({ type: MENUPROFILE_CHANGE_CURRENT_PAGE, data: page });
  };
}

export function changeSortModel(model) {
  return async dispatch => {
    dispatch({ type: MENUPROFILE_CHANGE_SORT_MODEL, data: model });
  };
}

export function changePageSize(page) {
  return async dispatch => {
    dispatch({ type: MENUPROFILE_CHANGE_PAGE_SIZE, data: page });
  };
}

export function resetMenuprofileData() {
  return async dispatch => {
    dispatch({ type: MENUPROFILE_RESET_DATA });
  };
}
